import React from "react";
import "./Intro.css";

const Intro = () => {
  return (
    <section className="intro">
      <h2 className="intro__title">Чего мы там не видели?</h2>
      <p className="intro__text">
        По опросам ВЦИОМ, 95% россиян мечтают куда-нибудь поехать, но только 36%
        планируют провести отпуск в родной стране. Мол, чего мы тут, дома, не
        видели? На самом деле, Россия — это целая вселенная с ласковым морем
        юга, густыми лесами Саян и суровыми льдами плато Путорана. А ещё увидеть
        все эти красоты можно без миллионов на счету, загранпаспорта и
        многочасовых перелетов. Как, например, Вера Башмакова — смелая молодая
        мама, которая взяла в охапку троих детей, усадила их в свою «Ладу» и
        проехала 20 тысяч километров по родной стране. Мы выбрали и описали
        некоторые интересные места, достойные вашего отпуска.
      </p>
      <ul className="intro__list">
        <li className="intro__list-item">
          Часовых поясов <span className="span-accent">11</span>
        </li>
        <li className="intro__list-item">
          Объектов природного наследия ЮНЕСКО{" "}
          <span className="span-accent">12</span>
        </li>
        <li className="intro__list-item">
          Объектов культурного наследия ЮНЕСКО{" "}
          <span className="span-accent">16</span>
        </li>
        <li className="intro__list-item">
          Природных заповедников <span className="span-accent">105</span>
        </li>
        <li className="intro__list-item">
          Аэропортов <span className="span-accent">241</span>
        </li>
      </ul>
    </section>
  );
};

export default Intro;
